import DetailsContainer from "./DetailsContainer";

export default DetailsContainer;
